import { Component } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-header-dots',
  templateUrl: './header-dots.component.html'
})
export class HeaderDotsComponent {
  constructor(private route:Router) {
  }
  logot(){
    localStorage.clear();
    this.route.navigate(['/login']);
  }

  select() {
    this.route.navigate(['/select']);
  }
}
